module.exports = __webpack_public_path__ + "static/media/clothingImage.42242b94.jpg";